import { useEffect } from 'react'
import { fetchCurrentUser } from '../services/currentUserService'
import { useAuthentication } from './useAuthentication'

/** Refreshes authenticated user from GET api/my-user when session becomes active or token changes. */
export function useSyncCurrentUserOnLoad(enabled) {
  const { updateUserInfo, currentToken } = useAuthentication()

  useEffect(() => {
    if (!enabled || !currentToken) return undefined
    let cancelled = false
    fetchCurrentUser()
      .then((user) => {
        if (cancelled || !user) return
        updateUserInfo(user, { replace: true })
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [enabled, currentToken, updateUserInfo])
}

export default useSyncCurrentUserOnLoad
